import { useTranslation } from 'react-i18next';
// material
import { enUS, frFR } from '@mui/material/locale';
import {isNotBrowser} from "./useLocalStorage";

// ----------------------------------------------------------------------

const LANGS = [
  {
    label: 'French',
    value: 'fr',
    systemValue: frFR,
    icon: '/static/icons/ic_flag_fr.svg'
  },
  {
    label: 'English',
    value: 'en',
    systemValue: enUS,
    icon: '/static/icons/ic_flag_en.svg'
  },
];

const defaultLocation = 'i18nextLng';

export default function useLocales() {
  const { i18n, t: translate } = useTranslation();
  const langStorage = isNotBrowser() ? defaultLocation : localStorage.getItem(defaultLocation);
  const currentLang = LANGS.find((_lang) => _lang.value === langStorage) || LANGS[0];

  const handleChangeLanguage = (newlang) => {
    i18n.changeLanguage(newlang);
  };

  return {
    onChangeLang: handleChangeLanguage,
    translate,
    currentLang,
    allLang: LANGS
  };
}
